import APIService from "./APIService";

export default {
  getDadosConsolidadosBdgd(year) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-dados-consolidados-bdgd?year=${year}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getIndgerQtdSubByCompetencia(
    competenciaDe,
    competenciaAte
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-indger-qtd-sub-by-competencia?competenciaDe=${competenciaDe}&competenciaAte=${competenciaAte}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getIndgerQtdAlimentadoresByCompetencia(
    competenciaDe,
    competenciaAte
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-indger-qtd-alimentadores-by-competencia?competenciaDe=${competenciaDe}&competenciaAte=${competenciaAte}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getIndgerQtdConjByCompetencia(
    competenciaDe,
    competenciaAte
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-indger-qtd-conj-by-competencia?competenciaDe=${competenciaDe}&competenciaAte=${competenciaAte}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getBdgdQtdTrafosBySub(
    year
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-bdgd-qtd-trafos-by-sub?year=${year}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getItensFaltantesByTipoAndEntidade(
    tipo,
    entidade,
    competencia,
    year
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-itens-faltantes-by-tipo-and-entidade?tipo=${tipo}&entidade=${entidade}&competencia=${competencia}&year=${year}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getBdgdMaxDataRegistroByYear(
    year,
    table
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-bdgd-max-data-registro-by-year?year=${year}&table=${table}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getQtdTotalUcs(
    year
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-qtd-total-ucs?year=${year}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  getQtdUcsByChaveEntidade(
    year,
    entidade
  ) {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get(
          `dashboard-bdgd-indger/get-qtd-ucs-by-chave-entidade?year=${year}&entidade=${entidade}`
        )
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  },
  downloadXlsxBdgdQtdTrafosBySub(year, config) {
    return APIService.apiCall().get(`dashboard-bdgd-indger/download-xlsx-bdgd-qtd-trafos-by-sub?year=${year}`, {
      responseType: 'blob',  
      ...config
    });
  },
};
